<template>
  <div class="resolveItem">
    <img class="logo" :src="require('@/assets/image/' + item.logoType + '.png')" alt="logo"/>
    <p class="itemName">{{item.name}}</p>
    <p class="itemDetails">{{item.details}}</p>
    <el-button type="primary" plain @click="toDetails">查看更多</el-button>
  </div>
</template>

<script>
export default {
  name: 'resolveItem',
  props: {
    item: {
      type: Object,
      default () {
        return {
          logoType: '',
          name: '',
          details: '',
          route: ''
        }
      }
    },
    index: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
    }
  },
  methods: {
    toDetails () {
      this.$router.push(this.item.route)
    }
  }
}
</script>

<style scoped lang="less">
.resolveItem{
  width: 380px;
  height: 420px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 6px;
  padding-top: 51px;
  box-sizing: border-box;
  box-shadow:0px 10px 30px 0px rgba(234,234,234,0.2);
  margin-left: 20px;
  &:nth-child(3n+1){
    margin-left: 0;
  }
  .logo{
    width: 85px;
    height: 99px;
    display: block;
    margin: 0 auto;
    margin-bottom: 40px;
  }
  .itemName{
    font-size: 22px;
    margin-bottom: 27px;
  }
  .itemDetails{
    color: #A3A3A3;
    font-size: 16px;
    width: 209px;
    line-height: 23px;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}
</style>
